import { useSelector } from "react-redux";

import { useTemplateGroupActions } from "store/TemplateGroupSlice";

const useTemplateGroup = () => {
  const { loadTemplateGroup, clearTemplateGroup } = useTemplateGroupActions();

  const { templateGroup } = useSelector((state) => state.TemplateGroupSlice);

  return { loadTemplateGroup, clearTemplateGroup, templateGroup };
};

export default useTemplateGroup;
